import Vue from 'vue'
import VueRouter from 'vue-router'
import Dash from '../views/Dash.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/user_signup/:token',
    name: 'UserSignup',
    component: () => import(/* webpackChunkName: "home" */ '../views/UserSignup.vue')
  },
  {
    path: '/',
    name: 'Dash',
    component: Dash,
    children: [
      {
        path: '/admin',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
      },
      {
        path: '/menu',
        name: 'Menu',
        component: () => import(/* webpackChunkName: "home" */ '../views/Menu.vue')
      },
      {
        path: '/menu/choices/:id',
        name: 'MenuChoice',
        component: () => import(/* webpackChunkName: "home" */ '../views/MenuChoices.vue')
      },
      {
        path: '/session',
        name: 'Sessions',
        component: () => import(/* webpackChunkName: "home" */ '../views/Session.vue')
      },
      {
        path: '/session/:id/messages',
        name: 'SessionMessages',
        component: () => import(/* webpackChunkName: "home" */ '../views/Messages.vue')
      },
      {
        path: '/permission',
        name: 'Permission',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Permission.vue')
      },
      {
        path: '/role',
        name: 'Role',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Role.vue')
      },
      {
        path: '/user',
        name: 'User',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/User.vue')
      },
      {
        path: '/billing',
        name: 'Billing',
        component: () => import(/* webpackChunkName: "admin" */ '../views/Billing.vue')
      },
      {
        path: '/airtime',
        name: 'Airtime',
        component: () => import(/* webpackChunkName: "home" */ '../views/Airtime.vue')
      },
      {
        path: '/reviews',
        name: 'Reviews',
        component: () => import(/* webpackChunkName: "home" */ '../views/Reviews.vue')
      },
      {
        path: '/kplc_token',
        name: 'KPLC_Token',
        component: () => import(/* webpackChunkName: "home" */ '../views/kplc_token.vue')
      },
      {
        path: '/kplc_postpaid',
        name: 'KPLC_PostPaid',
        component: () => import(/* webpackChunkName: "home" */ '../views/kplc_postpaid.vue')
      },
      {
        path: '/bongapoints',
        name: 'Bongapoints',
        component: () => import(/* webpackChunkName: "home" */ '../views/Bongapoints.vue')
      },
      {
        path: '/water',
        name: 'Water',
        component: () => import(/* webpackChunkName: "home" */ '../views/Water.vue')
      },
      {
        path: '/paytv',
        name: 'paytv',
        component: () => import(/* webpackChunkName: "home" */ '../views/PayTV.vue')
      },
      {
        path: '/loans',
        name: 'loan',
        component: () => import(/* webpackChunkName: "home" */ '../views/LoanRequests.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
